import React from "react";
import NavBar from "./components/navbar";
import Graph from "./components/graph";

function App() {
  return (
    <div className="App">
      <NavBar />
      <Graph />
    </div>
  );
}

export default App;
